import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import OrderPage from "./components/pages/OrderPage";
import MainPage from "./components/pages/MainPage";
import SummaryPage from "./components/pages/SummaryPage";
import OkPage from "./components/pages/OkPage";
import PaymentErrorPage from "./components/pages/PaymentErrorPage";
import BookingCancelPage from "./components/pages/BookingCancelPage";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import "./styles.css";
import { useTranslation } from "react-i18next";

function App() {
  const { t, i18n } = useTranslation();

  const [isI18nReady, setIsI18nReady] = useState(false);

  useEffect(() => {
    i18n.on("initialized", () => {
      setIsI18nReady(true);
    });

    // fallback – jeśli i18n już gotowe
    if (i18n.isInitialized) setIsI18nReady(true);

    // cleanup
    return () => i18n.off("initialized");
  }, [i18n]);


  useEffect(() => {
    document.title = t("appTitle");
  }, [t]);

  if (!isI18nReady) return null;

  return (
    <div
      className="main"
      style={{
        //backgroundImage: "url(/bg.png)",
        //backgroundRepeat: "repeat",
        height: "100%",
        position: "relative",
        width: "100%",
      }}
    >
      <Navbar />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />}></Route>
          <Route path="/order" element={<OrderPage />}></Route>
          <Route path="/summary" element={<SummaryPage />}></Route>
          <Route path="/booking/ok" element={<OkPage />}></Route>
          <Route path="/booking/error" element={<PaymentErrorPage />}></Route>
          <Route path="/booking/cancel" element={<BookingCancelPage />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
